import View from "../framework/view";
import grapesjs, {Editor} from 'grapesjs';
import template from "../../pugc/string-reorder";

const classname = "string-reorder";

type Listener = (strings: string[]) => void;

export class StringReorder extends View {

    private initialising = false;

    readonly tagTitle: string;

    readonly data: string[];

    private editor?: Editor;

    private listener? : Listener;

    constructor(tagTitle: string, strings: string[], listener?: Listener) {
        super(classname);
        this.tagTitle = tagTitle;
        this.data = strings.splice(0);
        this.listener = listener;
    }

    private async configureEditor() {

        // handle repaint of parent
        if (this.initialising) {
            return;
        }
        this.initialising = true;

        // @ts-ignore
        await import("grapesjs/dist/css/grapes.min.css");

        const elt = this.elt();
        if (elt.data("init") || this.editor) {
            return;
        }
        elt.data("init", true);

        const containerId = `#${this.getUuid()}-gjs`;

        const reorderPlugin = (editor: Editor) => {

            editor.Components.addType(this.tagTitle, {
                isComponent: (el) => {
                    return el.tagName == "DIV"
                },
                extend: "text",
                model: {
                    defaults: {
                        tagName: "div",
                        droppable: false,
                        editable: false
                    }
                }
            });

        };

        // @ts-ignore
        const editor = this.editor = grapesjs.init({
            container: containerId,
            fromElement: true,
            height: '600px',
            width: 'auto',
            storageManager: false,
            plugins: [ reorderPlugin ],
            canvasCss: `
div {
    margin-bottom: 0.5em;
}            
.gjs-dashed *[data-gjs-highlightable] {
      outline: none !important;
}
div {
    cursor: move;
}
body {
  font-family: 'Inter', sans-serif;
  color: black;
}
.product-hidden {
  font-style: italic;
  margin-left: 1em;
}
            `
        });

        editor.on("update", () => {
            const components = editor.getComponents();
            const strings = components.models.map(m =>  m.getAttributes()["data-string"] as string);
            this.listener && this.listener(strings);
        });


        editor.on("load", () => {
            const c = this.elt().find(".gjs-editor-cont");
            const f = this.elt().find("iframe.gjs-frame");
            const iframe = f[0] as HTMLIFrameElement;
            const doc = iframe.contentDocument;
            if (doc) {
                const height = doc.body.scrollHeight;
                f.height(height);
                c.height(height + 40);
            }
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            strings: this.data
        }
        const out = this.pug(template, data);

        this.afterUpdate(() => {
           this.configureEditor();
        });

        return out;

    }

}
